<script lang="ts">
  import searchIcon from "../../assets/search.svg?raw";
  import { onMount } from "svelte";
  import LibrarySearchAutocomplete from "./LibrarySearchAutocomplete.svelte";
  import LibrarySearchedTagPill from "./LibrarySearchedTagPill.svelte";

  let searchBar;

  let searchableTags = [];

  export let handleSearchChanged;

  let tagsSearched = [];
  let autocomplete;

  // TODO BL: Right now, this only gets run when the library becomes visible. I think this is fine.
  onMount(() => {
    fetch(`/app/library/all_tags`)
      .then((response) => response.json())
      .then((data) => {
        searchableTags = data;
      });
  });

  function handleCloseTag(tagIdx) {
    tagsSearched.splice(tagIdx, 1);
    tagsSearched = tagsSearched;
    autocomplete.handleUserTyped(searchBar);
    handleSearchChanged(searchBar.value, tagsSearched);
  }

  function submitWordSearch() {
    handleSearchChanged(searchBar.value, tagsSearched);
    // searchBar.value = "";
    autocomplete.close();
    // autocomplete.handleUserTyped(searchBar);
  }

  function submitTagSearch(tag) {
    tagsSearched.push(tag);
    tagsSearched = tagsSearched;
    searchBar.value = "";
    autocomplete.handleUserTyped(searchBar);
    handleSearchChanged(searchBar.value, tagsSearched);
  }

  function handleKeyDown(evt: KeyboardEvent) {
    const bubbled = autocomplete.handleKeyDown(evt);
    if (!bubbled) {
      return;
    }
    switch (evt.key) {
      case "Backspace":
        if (searchBar.value !== undefined && searchBar.value !== "") {
          return;
        }
        tagsSearched.pop();
        tagsSearched = tagsSearched;
        handleSearchChanged(searchBar.value, tagsSearched);
    }
  }
  // const USER_TYPING_GAP_MILLIS = 300;
  // let typedTimeout = null;
  function handleUserTyped() {
    autocomplete.handleUserTyped(searchBar);

    // if (typedTimeout !== null) {
    //   clearTimeout(typedTimeout);
    // }

    // typedTimeout = setTimeout(() => {
    //   handleSearchChanged(searchBar.value, tagsSearched);
    //   typedTimeout = null;
    // }, USER_TYPING_GAP_MILLIS);
  }
</script>

<div class="searchbar font-family-bardic-sans">
  <div
    class="searchbar-input"
  >
    <div class="width-1rem blue">
      {@html searchIcon}
    </div>
    {#each tagsSearched as tag, tagIdx (tag)}
      <LibrarySearchedTagPill
        {tag}
        closePressedCallback={() => handleCloseTag(tagIdx)}
      />
    {/each}
    <input
      type="text"
      on:input={handleUserTyped}
      bind:this={searchBar}
      placeholder="Search for a sound"
      on:keydown={handleKeyDown}
    />
  </div>
  <LibrarySearchAutocomplete
    bind:this={autocomplete}
    {searchableTags}
    {submitWordSearch}
    {submitTagSearch}
  />
</div>
